// // AdminTable.jsx
// import React, { useEffect, useState } from "react";



// import { adminSendRequestService } from "../apiservice/adminSendRequestService";
// import { useAuth } from "../../context/auth"
// import { MdEmail } from "react-icons/md";
// import { BiTransfer } from "react-icons/bi";
// import { FaTrash } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { FiRefreshCcw } from "react-icons/fi";

// import { AiOutlineWarning } from "react-icons/ai";

// const AdminTableView = ({ adminDetails, handleRemoveCopier, fetchCopierData, loadingData, profileData }) => {






//     const { getLoginToken, getLoginMail, getGoogleAuthToken } = useAuth();
//     const [email, setEmail] = useState("");
//     const [loading, setLoading] = useState(false);
//     const loginMail = getLoginMail()

//     const token = getLoginToken() || getGoogleAuthToken()


//     // Here handleCopierEmail function for Sent request for from admin side

//     const handleCopierEmail = (e) => {
//         const email = e.target.value;

//         if (email !== loginMail) {

//             setEmail(email)
//         }
//         else {
//             setEmail("")
//             toast.error('Use different mail');
//         }


//     }


//     // Function for send the copier Request from admin side


//     const validUser = (email = '') => {
//         if (!email) {
//             return "Email and password are required";
//         }
//         if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email)) {
//             return "Invalid email format.";
//         }

//         return null;
//     };


//     const handleSendRequest = async () => {



//         try {
//             const dataerror = validUser(email);


//             if (dataerror) {

//                 throw new Error(dataerror)
//             }
//         }

//         catch (error) {

//             toast.error(error.message)


//             return;

//         }
//         try {
//             setLoading(true);

//             const data = { copying_admin_email: email };
//             const response = await adminSendRequestService(data, token);

//             if (response.status === 200 && !response.data?.error) {


//                 await new Promise(resolve => setTimeout(resolve, 3000));
//                 toast.success(response.data?.data)
//             }

//             else {
//                 toast.error(response.data?.data)
//             }
//         } catch (error) {

//             toast.error(error?.response?.data?.error || error.message)

//             console.error("API Error:", error?.response?.data?.error || error.message);

//         } finally {
//             setLoading(false);
//         }
//     };

//     // const handleRefresh = () => {


//     //         useEffect(()=>{
//     //             adminDetails
//     //         })

//     //     };



//     // Here we are check the current mail of the user 
//     const currentMail = getLoginMail();

//     const adminMail = adminDetails.filter((client) => client.admin !== currentMail);

//     //code for current page and set set current and for next pages
//     const [currentPage, setCurrentPage] = useState(1);
//     const rowsPerPage = 15;

//     //    Tottal pages calcuate
//     const totalPages = Math.ceil(adminDetails.length / rowsPerPage);

//     // Get current page data
//     const startIdx = (currentPage - 1) * rowsPerPage;
//     const adminCurrentRows = adminMail.slice(startIdx, startIdx + rowsPerPage);


//     const [isOpen, setIsOpen] = useState(true);

//     if (!isOpen) return null


//     return (
//         //  Ui part start from here  and  the is main div 

//         <div className='  h-full overflow-auto '>
//             <div className="overflow-x-auto  p-4">


//                 <div className="flex items-start w-[900px] space-x-2 sm:w-[100%] lg:[100%] md:w-[100%] ml-[-5px] p-3 border border-gray-200 bg-mylightbg dark:bg-mydarkbg shadow-2xl rounded-lg my-2">
//                     <AiOutlineWarning className="text-yellow-500 text-xl  w-5 h-5" />
//                     <p className="  text-sm text-mytextlight dark:text-mytextdark">
//                         The Trade Copier service is strictly limited to Live accounts of SEBI-registered users and can be accessed only through an invitation link.
//                     </p>
//                 </div>

//                 <div className="  backdrop-blur-md bg-white/70 dark:bg- dark:bg-[#1d1d1f] rounded-xl shadow-lg pl-4 pr-4 pb-4 min-w-[900px] min-h-[500px] ">


//                     <div className="flex justify-end items-center space-x-2 space-y-4">


//                         {/* These are top tools  */}
//                         <div className="flex flex-row md:flex-row md:items-center md:justify-between gap-3 items-center mb-4 mt-3 ">

//                             <div className="relative w-60 text-mytextlight dark:text-mytextlight">

//                                 <input
//                                     type="email"
//                                     value={email}
//                                     onChange={handleCopierEmail}
//                                     placeholder="Enter email"
//                                     className="w-full pr-10 p-2 border border-gray-300 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
//                                 />
//                                 <span className="absolute inset-y-0 right-0 flex items-center pr-2 text-gray-500">
//                                     <MdEmail />
//                                 </span>
//                             </div>
//                             {/* Button of handle Send Copier Request */}
//                             {/* Simple button for handle the copoier sent request*/}
//                             <button
//                                 onClick={handleSendRequest}
//                                 disabled={loading}
//                                 className={`relative w-60 py-2 px-4 rounded text-white font-medium 
//     ${loading ? 'bg-blue-400 blur-[1px] cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}
//     transition-all duration-300 flex items-center justify-center `}
//                             >
//                                 {loading ? (
//                                     <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                                 ) : (
//                                     "Send Request"
//                                 )}
//                                 <span className="absolute inset-y-0 right-0 flex items-center pr-2 text-white">
//                                     <BiTransfer />
//                                 </span>
//                             </button>


//                             <button
//                                 onClick={fetchCopierData}

//                                 className={`relative py-2 px-2 rounded-md border border-gray-400 text-gray-800 dark:text-white font-medium  
    
//      flex items-center justify-center hover:text-blue-500 transition-transform duration-500 hover:rotate-180 `}
//                             >

//                                 <FiRefreshCcw className="h-5 w-5 text-center " />


//                             </button>

//                             {/* <button
//                                 onClick={fetchCopierData}
//                                 className=" relative mt-2  text-gray-600 flex justify-center items-center dark:text-white p-2 rounded-md border border-gray-300 hover:bg-gray-100 mb-3 hover:text-blue-500 transition-transform duration-500 hover:rotate-180"
//                                 title="Refresh"
//                             >
//                                 <FiRefreshCcw className="h-5 w-5 text-center " />
//                             </button> */}





//                         </div>
//                     </div>


//                     {/* Columns for Table */}
//                     {/* Table start from here and table code   */}

//                     <table className="min-w-full table-auto text-xs text-left border border-[#94BBE9] ">
//                         <thead className="bg-blue-50 text-blue-800">
//                             <tr>



//                                 <th className="min-w-[10px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                     <div className="flex items-center justify-between gap-1">
//                                         Admin Mail

//                                     </div>
//                                 </th>
//                                 <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                     <div className="flex items-center justify-between gap-1">
//                                         Status



//                                     </div>

//                                 </th>

//                                 <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                     <div className="flex items-center justify-between gap-1">
//                                         Copier In Use



//                                     </div>

//                                 </th>

//                                 <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                     <div className="flex items-center justify-between gap-1">
//                                         Multipiler



//                                     </div>



//                                 </th>


//                                 <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                     <div className="flex items-center justify-between gap-1">
//                                         Pause Status



//                                     </div>






//                                 </th>

//                                 <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                     <div className="flex items-center justify-between gap-1">
//                                         Action

//                                     </div>
//                                 </th>


//                             </tr>
//                         </thead>
//                         <tbody>

//                             {/* Rows for admin Table */}

//                             {/* Rows if admin table lenght is zero then show no data found */}



//                             {adminCurrentRows.length === 0 ? (
//                                 <>
//                                     <tr>
//                                         <td
//                                             colSpan={6} // adjust this number to match your total number of columns
//                                             className=" min-w-[30px] text-center py-4 border border-[#94BBE9] text-gray-500 dark:text-black"
//                                         >
//                                             No alerts found
//                                         </td>





//                                     </tr>

//                                     {profileData?.account_type === "Free" && (
//                                         <tr>
//                                             <td
//                                                 colSpan={6}
//                                                 className="min-w-[30px] text-center py-4 border text-gray-500 dark:text-black"
//                                             >
//                                                 Trade copier isn’t available on Free accounts. Please upgrade your plan to access this feature.



//                                             </td>
//                                         </tr>
//                                     )}
//                                 </>


//                                 //  here is if data got from api then here data wil show 
//                             ) : (

//                                 Array.isArray(adminCurrentRows) && adminCurrentRows.map((row, idx) => (


//                                     <tr key={idx} className="border-b border-[#94BBE9] text-mytextlight dark:text-mytextdark ">



//                                         <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9]  ">
//                                             {row.admin}
//                                         </td>

//                                         {/* status the code if the user is not here logic for the status so ero erisksdj   */}
//                                         <td className="min-w-[30px] px-2 py-2  border border-[#94BBE9] ">
//                                             {row.status}
//                                         </td>

//                                         {/* * In this how to show quantity of the multiple data   */}

//                                         <td className="min-w-[30px] px-2 py-2  border border-[#94BBE9] ">
//                                             {row.working_on}
//                                         </td>

//                                         <td className="min-w-[30px] px-2 py-2  border border-[#94BBE9] ">

//                                             {/* In this how to show quantity of the multiple data   */}
//                                             {row.quantity_multiplier
//                                             }
//                                         </td>

//                                         <td className="min-w-[30px] px-2 py-2 border  border-[#94BBE9] ">

//                                             <div className=" flex gap-4 items-center">

//                                                 {(row.pause_copier) ? "Inactive" : "Active"}



//                                             </div>



//                                         </td>

//                                         <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] ">
//                                             {/* Status logic for status show the status of the code  */}
//                                             {row.status === "Pending" && (
//                                                 <>



//                                                     <button
//                                                         onClick={() => handleRemoveCopier(row.id)}
//                                                         className="flex items-center justify-center gap-1 bg-red-500 text-white rounded text-xs
//                                                                                                           w-32 h-8 sm:w-36 sm:h-9"
//                                                     >
//                                                         <FaTrash className="text-sm" />
//                                                         Remove Request
//                                                     </button>
//                                                 </>
//                                             )}

//                                             {/* Shows the status of the code if user is approved */}

//                                             {row.status === "Approved" && (
//                                                 <div className="  ">



//                                                     <button
//                                                         onClick={() => handleRemoveCopier(row.id)}
//                                                         className="flex items-center justify-center gap-1 bg-red-500 text-white rounded text-xs
//                                                                                                           w-32 h-8 sm:w-36 sm:h-9"
//                                                     >
//                                                         <FaTrash className="text-sm" />
//                                                         Remove Request
//                                                     </button>


//                                                 </div>

//                                             )}






//                                         </td>




//                                     </tr>

//                                 ))
//                             )}




//                         </tbody>
//                     </table>


//                 </div>

//                 {/* Pagination Buttons */}
//                 <div className="  flex justify-center gap-2 flex-wrap mt-2">
//                     {Array.from({ length: totalPages }, (_, index) => (
//                         <button
//                             key={index + 1}
//                             onClick={() => setCurrentPage(index + 1)}
//                             className={`px-3 py-1 text-sm sm:text-base rounded ${currentPage === index + 1
//                                 ? "bg-blue-600 text-white"
//                                 : "bg-gray-200 text-black"
//                                 }`}
//                         >
//                             Page {index + 1}
//                         </button>
//                     ))}
//                 </div>

//             </div>




//         </div>


//     );
// };

// export default AdminTableView;






// AdminTable.jsx
import React, { useEffect, useState } from "react";

import { adminSendRequestService } from "../apiservice/adminSendRequestService";
import { useAuth } from "../../context/auth"
import { MdEmail } from "react-icons/md";
import { BiTransfer } from "react-icons/bi";
import { FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { FiRefreshCcw } from "react-icons/fi";

import { AiOutlineWarning } from "react-icons/ai";

const AdminTableView = ({ adminDetails, handleRemoveCopier, fetchCopierData, loadingData, profileData }) => {

    const { getLoginToken, getLoginMail, getGoogleAuthToken } = useAuth();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const loginMail = getLoginMail()

    const token = getLoginToken() || getGoogleAuthToken()

    // Here handleCopierEmail function for Sent request for from admin side

    const handleCopierEmail = (e) => {
        const email = e.target.value;

        if (email !== loginMail) {

            setEmail(email)
        }
        else {
            setEmail("")
            toast.error('Use different mail');
        }
    }

    // Function for send the copier Request from admin side

    const validUser = (email = '') => {
        if (!email) {
            return "Email and password are required";
        }
        if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email)) {
            return "Invalid email format.";
        }

        return null;
    };

    const handleSendRequest = async () => {

        try {
            const dataerror = validUser(email);

            if (dataerror) {
                throw new Error(dataerror)
            }
        }
        catch (error) {
            toast.error(error.message)
            return;
        }
        
        try {
            setLoading(true);

            const data = { copying_admin_email: email };
            const response = await adminSendRequestService(data, token);

            if (response.status === 200 && !response.data?.error) {
                await new Promise(resolve => setTimeout(resolve, 3000));
                toast.success(response.data?.data)
            }
            else {
                toast.error(response.data?.data)
            }
        } catch (error) {
            toast.error(error?.response?.data?.error || error.message)
            console.error("API Error:", error?.response?.data?.error || error.message);
        } finally {
            setLoading(false);
        }
    };

    // Here we are check the current mail of the user 
    const currentMail = getLoginMail();

    const adminMail = adminDetails.filter((client) => client.admin !== currentMail);

    //code for current page and set set current and for next pages
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 15;

    // Total pages calculate
    const totalPages = Math.ceil(adminDetails.length / rowsPerPage);

    // Get current page data
    const startIdx = (currentPage - 1) * rowsPerPage;
    const adminCurrentRows = adminMail.slice(startIdx, startIdx + rowsPerPage);

    const [isOpen, setIsOpen] = useState(true);

    if (!isOpen) return null

    return (
        <div className='h-full overflow-auto'>
            <div className="overflow-x-auto p-4">
                {/* Warning Box - Dark Mode Added */}
                <div className="flex items-start w-[900px] space-x-2 sm:w-[100%] lg:[100%] md:w-[100%] ml-[-5px] p-3 border border-gray-200 dark:border-gray-700 bg-mylightbg dark:bg-gray-800 shadow-2xl rounded-lg my-2">
                    <AiOutlineWarning className="text-yellow-500 text-xl w-5 h-5" />
                    <p className="text-sm text-mytextlight dark:text-gray-300">
                        The Trade Copier service is strictly limited to Live accounts of SEBI-registered users and can be accessed only through an invitation link.
                    </p>
                </div>

                {/* Main Container - Dark Mode Added */}
                <div className="backdrop-blur-md bg-white/70 dark:bg-[#1d1d1f]/90 rounded-xl shadow-lg pl-4 pr-4 pb-4 min-w-[900px] min-h-[500px]">
                    
                    {/* Top Tools Section - Dark Mode Added */}
                    <div className="flex justify-end items-center space-x-2 space-y-4">
                        <div className="flex flex-row md:flex-row md:items-center md:justify-between gap-3 items-center mb-4 mt-3">
                            
                            {/* Email Input - Dark Mode Added */}
                            <div className="relative w-60">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={handleCopierEmail}
                                    placeholder="Enter email"
                                    className="w-full pr-10 p-2 border border-gray-300 dark:border-gray-600 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400"
                                />
                                <span className="absolute inset-y-0 right-0 flex items-center pr-2 text-gray-500 dark:text-gray-400">
                                    <MdEmail />
                                </span>
                            </div>
                            
                            {/* Send Request Button */}
                            <button
                                onClick={handleSendRequest}
                                disabled={loading}
                                className={`relative w-60 py-2 px-4 rounded text-white font-medium 
                                    ${loading ? 'bg-blue-400 blur-[1px] cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}
                                    transition-all duration-300 flex items-center justify-center`}
                            >
                                {loading ? (
                                    <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                ) : (
                                    "Send Request"
                                )}
                                <span className="absolute inset-y-0 right-0 flex items-center pr-2 text-white">
                                    <BiTransfer />
                                </span>
                            </button>

                            {/* Refresh Button - Dark Mode Added */}
                            <button
                                onClick={fetchCopierData}
                                className="relative py-2 px-2 rounded-md border border-gray-400 dark:border-gray-600 text-gray-800 dark:text-gray-300 font-medium flex items-center justify-center hover:text-blue-500 dark:hover:text-blue-400 transition-transform duration-500 hover:rotate-180"
                            >
                                <FiRefreshCcw className="h-5 w-5 text-center" />
                            </button>
                        </div>
                    </div>

                    {/* Table - Dark Mode Added */}
                    <table className="min-w-full table-auto text-xs text-left border border-[#94BBE9] dark:border-gray-700">
                        <thead className="bg-blue-50 dark:bg-gray-800 text-blue-800 dark:text-gray-200">
                            <tr>
                                <th className="min-w-[10px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                    <div className="flex items-center justify-between gap-1">
                                        Admin Mail
                                    </div>
                                </th>
                                <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                    <div className="flex items-center justify-between gap-1">
                                        Status
                                    </div>
                                </th>
                                <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                    <div className="flex items-center justify-between gap-1">
                                        Copier In Use
                                    </div>
                                </th>
                                <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                    <div className="flex items-center justify-between gap-1">
                                        Multiplier
                                    </div>
                                </th>
                                <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                    <div className="flex items-center justify-between gap-1">
                                        Pause Status
                                    </div>
                                </th>
                                <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                    <div className="flex items-center justify-between gap-1">
                                        Action
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {adminCurrentRows.length === 0 ? (
                                <>
                                    <tr>
                                        <td
                                            colSpan={6}
                                            className="min-w-[30px] text-center py-4 border border-[#94BBE9] dark:border-gray-700 text-gray-500 dark:text-gray-400"
                                        >
                                            No alerts found
                                        </td>
                                    </tr>
                                    {profileData?.account_type === "Free" && (
                                        <tr>
                                            <td
                                                colSpan={6}
                                                className="min-w-[30px] text-center py-4 border border-[#94BBE9] dark:border-gray-700 text-gray-500 dark:text-gray-400"
                                            >
                                                Trade copier isn't available on Free accounts. Please upgrade your plan to access this feature.
                                            </td>
                                        </tr>
                                    )}
                                </>
                            ) : (
                                Array.isArray(adminCurrentRows) && adminCurrentRows.map((row, idx) => (
                                    <tr key={idx} className="border-b border-[#94BBE9] dark:border-gray-700 text-mytextlight dark:text-gray-300">
                                        <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                            {row.admin}
                                        </td>
                                        <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                            {row.status}
                                        </td>
                                        <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                            {row.working_on}
                                        </td>
                                        <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                            {row.quantity_multiplier}
                                        </td>
                                        <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                            <div className="flex gap-4 items-center">
                                                {(row.pause_copier) ? "Inactive" : "Active"}
                                            </div>
                                        </td>
                                        <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                            {row.status === "Pending" && (
                                                <button
                                                    onClick={() => handleRemoveCopier(row.id)}
                                                    className="flex items-center justify-center gap-1 bg-red-500 hover:bg-red-600 text-white rounded text-xs w-32 h-8 sm:w-36 sm:h-9 transition-colors duration-200"
                                                >
                                                    <FaTrash className="text-sm" />
                                                    Remove Request
                                                </button>
                                            )}
                                            {row.status === "Approved" && (
                                                <button
                                                    onClick={() => handleRemoveCopier(row.id)}
                                                    className="flex items-center justify-center gap-1 bg-red-500 hover:bg-red-600 text-white rounded text-xs w-32 h-8 sm:w-36 sm:h-9 transition-colors duration-200"
                                                >
                                                    <FaTrash className="text-sm" />
                                                    Remove Request
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination Buttons - Dark Mode Added */}
                <div className="flex justify-center gap-2 flex-wrap mt-2">
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index + 1}
                            onClick={() => setCurrentPage(index + 1)}
                            className={`px-3 py-1 text-sm sm:text-base rounded transition-colors duration-200 ${
                                currentPage === index + 1
                                    ? "bg-blue-600 text-white dark:bg-blue-500"
                                    : "bg-gray-200 text-black dark:bg-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600"
                            }`}
                        >
                            Page {index + 1}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AdminTableView;